import { Routes } from '@angular/router';
import { ConstantChampsFormulaires } from '../champs_formulaires/champs-formulaire.url';
import { GuardAdminService } from '../../../../services/guard/authorities/guard-admin.service';
import { ChampsFormulaireListComponent } from '../champs_formulaires/champs-formulaire-list.component';
import { ConstantTypeInputForm } from './type-input-form.url';
import { TypeInputFormListComponent } from './type-input-form-list.component';

/**
 * Ensemble des routes pour les costs rule.
 */
export const TYPE_INPUT_FORM_ROUTE: Routes = [
  {
    path: ConstantTypeInputForm.url.FEES.FEES_,
    canActivate: [GuardAdminService],
    children: [
      {
        path: '',
        redirectTo: ConstantTypeInputForm.url.FEES.LIST,
        pathMatch: 'full'
      },
      {
        path: ConstantTypeInputForm.url.FEES.LIST,
        component: TypeInputFormListComponent
      }
    ]
  }
];
